import {
  Component, Input, inject
} from '@angular/core';
import { IMAGES_URL, IOS_APP_LINK } from '@src/app/core/constants/system-list.constant';
import { CoreClass } from '@src/app/core/base/core.class';

@Component({
  selector: 'app-applestore-btn',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: false,
})
export class ApplestoreBtnComponent extends CoreClass {
  @Input() heading: string = '';
  IMAGES_URL: string = IMAGES_URL;
  IOS_APP: string = IOS_APP_LINK
}
